const fetchBillingSummary: any = async () => {
  const { data }: any = await dataFetch("/billing/summary");
  
  return data.value;
};

const fetchBillingPlans: any = async () => {
  const { data }: any = await dataFetch("/billing/plans");
  
  return data.value;
};

const fetchBillingPortal: any = async () => {
  const { data, status, error }: any = await dataFetch("/billing/billing-portal");
  
  if (status.value == "error") {
    return {
      data: null,
      status,
      error: error.value
    };
  }

  return {
    data: data.value,
    status,
    error: null
  };
};

const checkoutBillingPlan: any = async (plan: string, interval: string) => {
  const { data, status, error }: any = await dataFetch("/billing/checkout", {
    method: "post",
    body: {
      plan: plan,
      interval: interval
    }
  });

  if (status.value == "error") {
    return {
      data: null,
      status,
      error: error.value
    };
  }

  return {
    data: data.value,
    status,
    error: null
  };
};

const checkoutEnergyMonitoringAddon: any = async () => {
  const { data, status, error }: any = await dataFetch("/billing/checkout", {
    method: "post",
    body: {
      type: "energy_monitoring"
    }
  });

  if (status.value == "error") {
    return {
      data: null,
      status,
      error: error.value
    };
  }

  return {
    data: data.value,
    status,
    error: null
  };
};

const swapBillingSubscription: any = async (plan: string, interval: string) => {
  const { data, status, error }: any = await dataFetch("/billing/swap-subscription", {
    method: "post",
    body: {
      plan: plan,
      interval: interval
    }
  });

  if (status.value == "error") {
    return {
      data: null,
      status,
      error: error.value
    };
  }

  return {
    data: data.value,
    status,
    error: null
  };
};

export { fetchBillingSummary, fetchBillingPlans, fetchBillingPortal, checkoutBillingPlan, checkoutEnergyMonitoringAddon, swapBillingSubscription };
